import { render } from "./CreditLoansTable.vue?vue&type=template&id=384ac91c&scoped=true"
import script from "./CreditLoansTable.vue?vue&type=script&lang=js"
export * from "./CreditLoansTable.vue?vue&type=script&lang=js"

import "./CreditLoansTable.vue?vue&type=style&index=0&id=384ac91c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384ac91c"]])

export default __exports__